









































































































































































import {Vue, Component, Watch} from 'vue-property-decorator';
import {mapActions, mapGetters} from 'vuex';
import {API} from '@/services/api/api';
import Drift from 'drift-zoom';
import {getImage, Utils} from '@/utils/Utils';
import ShipListModel from '@/models/shiplist';
import Cropper from 'cropperjs';
import 'cropperjs/dist/cropper.css';

@Component({
  methods: {...mapActions(['showSuccessToast', 'showErrorToast'])},
  computed: {...mapGetters(['shipList'])},
})
export default class CreateFrameZone extends Vue {
  zoneName = '';

  selectedShip = null;
  cropper = null;
  focusedEndPoint = null;
  showSuccessToast: any;
  showErrorToast: any;
  frameFrom: number = null;
  frameUpto: number = null;
  btnLoader = false;
  isScreenLoading = true;
  shipValidationMsg = '';
  zoneValidationMsg = '';
  frameFromValidationMsg = '';
  frameUptoValidationMsg = '';
  commonValidationMsg = 'This field is required';
  lengthValidationMsg = 'Can not be more than 7 digits';

  shipList: ShipListModel[];
  zoneList = [];
  zoneData = [];
  MarkerWidth = 5;
  endX: any;
  startY = 0;
  isAutomatedEnable = true;
  zoneStartPoint: number = null;
  zoneEndPoint: number = null;

  endY: any;

  startX = this.MarkerWidth;

  shipImage: any = null;

  zoneID: number = null;
  drift: any = null;

  deckImageURL: string = '';
  scandResult: any = null;

  // change ship handler
  async changeShip() {
    this.validateShipSelect();
    this.zoneList = [];
    this.resetFrame();
    this.zoneName = '';
    if (this.selectedShip) {
      this.isScreenLoading = true;

      try {
        const params = {
          allzones: 0,
          withoutframe: 1,
        };
        const response = await API.fetchZoneListByShipID(params, this.selectedShip);

        if (response.data) {
          const data = response.data;
          this.zoneList = data;

          this.zoneData = data;
        } else {
          this.showErrorToast({msg: response.error});
        }
      } catch (error) {
        this.showErrorToast({msg: 'Network error'});
      } finally {
        this.isScreenLoading = false;
      }
    }
  }

  //Reset form
  resetFrame() {
    this.frameFrom = null;
    this.frameUpto = null;
    this.frameFromValidationMsg = '';
    this.frameUptoValidationMsg = '';
  }

  //validate ship select
  validateShipSelect() {
    if (!this.selectedShip) {
      this.shipValidationMsg = this.commonValidationMsg;
      return false;
    } else {
      this.shipValidationMsg = '';
      return true;
    }
  }

  //validate zone input
  validateZoneSelect() {
    if (this.zoneName === '' || this.zoneName.length < 1) {
      this.zoneValidationMsg = this.commonValidationMsg;
      return false;
    } else {
      this.zoneValidationMsg = '';
      return true;
    }
  }

  //validate frame from input
  validateFrameFrom() {
    if (this.frameFrom === null || this.frameFrom.toString().length < 1) {
      this.frameFromValidationMsg = this.commonValidationMsg;
      return false;
    } else if (this.frameFrom.toString().length > 7) {
      this.frameFromValidationMsg = this.lengthValidationMsg;
      return false;
    } else {
      this.frameFromValidationMsg = '';
      return true;
    }
  }

  //validate frame upto input
  validateFrameUpto() {
    if (this.frameUpto === null || this.frameUpto.toString().length < 1) {
      this.frameUptoValidationMsg = this.commonValidationMsg;
      return false;
    } else if (this.frameUpto.toString().length > 7) {
      this.frameUptoValidationMsg = this.lengthValidationMsg;
      return false;
    } else if (Number(this.frameFrom) >= Number(this.frameUpto)) {
      this.frameUptoValidationMsg = 'Frame upto must larger than frame from';
      return false;
    } else {
      this.frameUptoValidationMsg = '';
      return true;
    }
  }

  //load image , then download image from server as blob then convert it into base64 to draw image on canvas
  async setDeckImage() {
    const zone = this.zoneList.find((me) => me.zoneDeckId === this.zoneName);

    this.zoneEndPoint = zone.zoneEndPoint;
    this.zoneStartPoint = zone.zoneStartPoint;

    this.zoneID = zone.zoneId;

    const ship = this.zoneData.find((me) => me.zoneId === this.zoneID);

    this.scandResult = Utils.parseJson(ship.zone.drawing.scanResult);
    this.deckImageURL = await getImage(ship.zone.drawing.imagePath);
    this.isScreenLoading = false;
  }

  //initialize zoomed container on hover imag
  initDriftZoom() {
    document.querySelectorAll('.drift-bounding-box').forEach((element) => {
      element.remove();
    });
    this.isAutomatedEnable
      ? (this.drift = new Drift(this.$refs.image, {
          paneContainer: document.getElementById('ppppp'),
          // inlinePane: 900,
          inlineOffsetY: -85,
          containInline: true,
          handleTouch: false,
          inlinePane: false,
          hoverBoundingBox: true,
        }))
      : null;
  }

  //disable zoomed container on hover image
  disableDriftZoom() {
    if (this.drift) {
      this.drift.destroy();
    }
  }

  //toggle between manual and automatic mode
  onToggle() {
    this.isAutomatedEnable = !this.isAutomatedEnable;
    if (!this.isAutomatedEnable && this.deckImageURL !== null) {
      this.initCropper();
    } else {
      this.destroyCropper();
    }
  }

  //Find frames from from scaned data
  _findFrames() {
    if (this.scandResult !== null) {
      const zones = this.scandResult.Zones;

      const frames = this.scandResult.Frames;

      const zone = zones.find((zone) => {
        return zone.Zone.EndPoint.X === this.zoneEndPoint;
      });

      if (zone === undefined) {
        this.showErrorToast({msg: 'Frame markers not found on deck image.'});
      } else {
        const zoneNumber = zone.Zone.ZoneNumber;
        const framesMarker = frames.filter((frame) => {
          return frame.Frame.ZoneNumber === zoneNumber;
        });

        if (framesMarker.length === 1 || framesMarker === [] || framesMarker.length < 1) {
          this.showErrorToast({msg: 'Frame markers not found on deck image.'});
        } else {
          const length = framesMarker.length;
          this.frameFrom = framesMarker[0].Frame.FrameNumber;
          this.frameUpto = framesMarker[length - 1].Frame.FrameNumber;
          this.frameFromValidationMsg = '';
          this.frameUptoValidationMsg = '';
        }
      }
    } else {
      this.showErrorToast({msg: 'Frames not found'});
    }
  }

  //Validate all before submit to  API
  validateAll() {
    return (
      this.validateShipSelect() && this.validateZoneSelect() && this.validateFrameFrom() && this.validateFrameUpto()
    );
  }

  //form handler
  async _createHandler() {
    if (this.validateAll()) {
      try {
        this.btnLoader = true;
        const frameData = [];
        frameData.push({
          frameFrom: this.frameFrom,
          frameUpto: this.frameUpto,
        });
        const response = await API.createFrame({
          ZoneDeckId: this.zoneName,
          frameofZones: frameData,
        });
        if (response.data) {
          this.showSuccessToast({msg: response.message});
          this._clearForm();
          this.changeTabs();
        } else {
          this.showErrorToast({msg: response.error});
        }
      } catch (error) {
        this.showErrorToast({msg: 'Network Error'});
      } finally {
        this.btnLoader = false;
      }
    }
  }

  //navigate back
  changeTabs() {
    document.body.removeEventListener('keydown', this.keyDownEvent);
    this.$router.go(-1);
  }

  //Clear form
  _clearForm() {
    this.selectedShip = null;
    this.zoneName = '';
  }

  @Watch('shipList', {immediate: true})
  loadDeckList() {
    this.isScreenLoading = false;
  }

  @Watch('zoneName', {immediate: true})
  checkZone() {
    if (this.zoneName.toString().length > 0) {
      this.resetFrame();
      this.setDeckImage();
    }
  }

  mounted() {
    document.body.addEventListener('keydown', this.keyDownEvent);
  }
  keyDownEvent(event) {
    let e = event || window.event;
    Utils.keyDownEvent(e, this.cropper);
  }

  //cropbox auto initialize after image load
  onDeckLoad() {
    if (!this.isAutomatedEnable && this.deckImageURL !== null) {
      this.initCropper();
    }
  }

  // initialize crop box on image
  initCropper() {
    const t = this.$refs.image as HTMLImageElement;
    const _this = this;
    this.cropper = new Cropper(t, {
      crop() {
        const data = this.cropper.getData(true);
        _this.frameFrom = data.x;
        _this.frameUpto = data.x + data.width;
        _this.frameFromValidationMsg = '';
        _this.frameUptoValidationMsg = '';
      },
      preview: document.getElementById('ppppp'),
      viewMode: 2,
      data: {
        x: t.naturalWidth / 3,
        y: t.naturalHeight / 3,
        width: t.naturalWidth / 3,
        height: t.naturalHeight / 3,
      },
    });
  }

  //form update handler
  updateForm() {
    const data = this.cropper.getData(true);
    if (this.scandResult != null) {
      const frame = this.scandResult.Frames.filter((fram) => {
        return fram.Frame.EndPoint.X >= data.x && fram.Frame.EndPoint.X <= data.x + data.width;
      });
      if (frame.length > 1) {
        this.frameFrom = frame[0].Frame.FrameNumber;
        this.frameUpto = frame[frame.length - 1].Frame.FrameNumber;
        this.frameFromValidationMsg = '';
        this.frameUptoValidationMsg = '';
      }
    } else {
      this.showErrorToast({msg: 'Frames not found'});
    }
  }

  //destroy crop box cropper
  destroyCropper() {
    if (this.cropper) {
      this.cropper.destroy();
      this.cropper = null;
    }
  }

  //Reset image button
  _reseImage() {
    if (this.cropper) {
      this.cropper.reset();
    }
  }
}
